import { useNavigate } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

const PayCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-gray-900 to-black text-white px-6">
      <div className="w-full max-w-md">
        <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl shadow-2xl py-8 px-6 text-center">
          <div className="flex justify-center mb-6">
            <div className="bg-yellow-500/10 p-4 rounded-full">
              <AlertTriangle className="w-10 h-10 text-yellow-400" />
            </div>
          </div>
          <h1 className="text-xl tracking-tight mb-2">
            Payment Cancelled
          </h1>
          <p className="text-gray-400 mb-6 text-sm">
            Your payment was cancelled. No charges were made.
          </p>

          <div className="flex flex-col gap-3">
            <button
              onClick={() => navigate("/")}
              className="w-full py-3 rounded-xl bg-white text-black hover:bg-gray-200 transition"
            >
              Back to Home
            </button>
          </div>
        </div>

        <p className="text-center text-xs text-gray-500 mt-6">
          You can safely retry your transaction anytime
        </p>
      </div>
    </div>
  );
};

export default PayCancel;
